import { FormControl, MenuItem, Select, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import type { PeriodSelectorProps } from '../types';
import { formatPeriodLabel } from '../utils/dynamic-line-item-formatters';
import { periodSelectorStyles } from './styles';
import { dynamicInvoicePageSelectors, getSelectorAttribute } from '@vy/app-selectors';

export const PeriodSelector: FC<PeriodSelectorProps> = ({
  periods,
  selectedPeriodIndex,
  onPeriodChange,
}) => {
  if (periods.length <= 1) {
    return null;
  }

  return (
    <Stack sx={periodSelectorStyles.periodContainer}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center"
        }}>
        <Stack direction="row" spacing={1} sx={{
          alignItems: "center"
        }}>
          <Typography variant="body2" sx={periodSelectorStyles.periodLabel}>
            Period
          </Typography>
          <FormControl size="small">
            <Select
              value={selectedPeriodIndex}
              onChange={(event) => onPeriodChange(event)}
              displayEmpty
              sx={periodSelectorStyles.periodSelect}
              {...getSelectorAttribute(dynamicInvoicePageSelectors.content.periodSelect)}
            >
              {periods.map((period, index) => (
                <MenuItem key={index} value={index}>
                  {formatPeriodLabel(period.fromDate, period.toDate)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Stack>
    </Stack>
  );
};
